module.exports = __webpack_public_path__ + "img/06-uae2pm-1.42e2ebe6.png";